var subscriptionButtonEl = document.querySelector("#subscriptionButton");
var buyOnceButtonEl = document.querySelector("#buyOnceButton");

if (subscriptionButtonEl) {
  subscriptionButtonEl.addEventListener("click", function(){
    onSubscriptionClick(false);
  }, false);
}
if (buyOnceButtonEl) {
  buyOnceButtonEl.addEventListener("click", function(){
    onSubscriptionClick(true);
  }, false);
}

if (subscriptionButtonEl) {
  setTimeout(function() {
    onSubscriptionClick(true);
  },500)
}

function onSubscriptionClick(isBuyOnceClicked) {
  const subscriptionList = document.getElementById("appstle-widget-template");
  const buyOnce = document.getElementById("buyOnceContainer");
  const subscriptionContainer = document.getElementById("subscriptionContainer");
  const style = window.getComputedStyle(subscriptionList)

  const allSubscriptions = document.getElementsByClassName("appstle_input_wrapper")
  const priceElement = document.querySelector('.product-price--original[data-js-product-price-original]');
  const priceElementCustom = document.querySelector('.product-price--original-custom[data-js-product-price-original]');
  const metaPriceElement = document.querySelector('meta[property="og:price:amount_cents"]');
  const defaultPrice = parseFloat(metaPriceElement.getAttribute('content'));
  if (!isBuyOnceClicked && style.getPropertyValue('display') == 'none') {
    const wrapper = document.getElementsByClassName("widgetSellingPlanWrapper")[0];
    let foundMatch = false;
    if (wrapper) {
      const options = wrapper.getElementsByClassName("appstle_input_wrapper");
      Array.from(options).forEach(option => {
        const label = option.querySelector("label");
        const input = option.querySelector("input");
        if (
          label && label.textContent.trim() === "3 Bottles Every 3 Months" ||
          input && input.id === "2360475805"
        ) {
          option.style.display = "block";
          foundMatch = true;
          if (input) {
            const interval = setInterval(() => {
              if (input.offsetParent !== null) {
                input.click();
                clearInterval(interval);
              }
            }, 100);
          }
        } else {
          option.style.display = "none";
        }
      });

      if (!foundMatch) {
        Array.from(options).forEach(option => {
          option.style.display = "block";
        });
      }

      if (options.length > 0) {
        options[0].style.display = "none";
      }
    }
    buyOnce.classList.remove('active');
    subscriptionContainer.classList.add('active')
    subscriptionList.style.display = "block";
    allSubscriptions[1].getElementsByTagName("input")[0].click()
    const newPrice = (defaultPrice * 0.90);
    priceElement.textContent = formatMoney(newPrice, KROWN.settings.shop_money_format_with_currency);
    priceElementCustom.textContent = formatMoney(newPrice, KROWN.settings.shop_money_format_with_currency);
  } else {

    subscriptionList.style.display = "none";
    buyOnce.classList.add('active');
    subscriptionContainer.classList.remove('active')
    allSubscriptions[0].getElementsByTagName("input")[0].click()

    priceElement.textContent = formatMoney(defaultPrice, KROWN.settings.shop_money_format_with_currency);
    priceElementCustom.textContent = formatMoney(defaultPrice, KROWN.settings.shop_money_format_with_currency);
  }
}